import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { compose } from 'utils/react';
import { Row, Section } from 'components';
import { BUILDER } from 'shared/abilities';
import globalClasses from 'theme/facility-globals.scss';
import { section, stylesModal } from '../decorators';

const storageIpsum = `
  Boat storage gotta boat. Gotta park the RV affordable cheap facility free lock. Accessible metro area,
  across the region storage solution. All your belongings cartons stuffed animals season clothing short
  term longterm. Pay in advance manager maintenance clean unit no vacancy, reports tab move-in lead tenant.
`;

const StackingThreeColumn = ({ children, sectionStyle = {} }) => {
  const [left, center, right, Carousel] = React.Children.toArray(children);

  return (
    <Section
      className={globalClasses.section}
      Carousel={Carousel}
      {...sectionStyle}
    >
      <Row>
        <Col xs={12} md={4}>{left}</Col>
        <Col xs={6} md={4}>{center}</Col>
        <Col xs={6} md={4}>{right}</Col>
      </Row>
    </Section>
  );
};
StackingThreeColumn.propTypes = {
  children: PropTypes.node.isRequired,
  sectionStyle: PropTypes.object,
};

const component = compose(
  stylesModal(),
  section(
    { name: '3 Columns: Alt Mobile Stack', category: 'Content Layout' },
    {
      subsections: [
        { accepts: ['ContentBox', 'DirectionsText', 'Image', 'Accordion'] },
        { accepts: ['ContentBox', 'DirectionsText', 'Image', 'Accordion'] },
        { accepts: ['ContentBox', 'DirectionsText', 'Image', 'Accordion'] },
        { accepts: ['Carousel'] },
      ],
      defaults: [
        ['ContentBox', {
          rawContentState: {
            blocks: [
              {
                key: 'db2mm',
                text: storageIpsum,
                type: 'unstyled',
                depth: 0,
                inlineStyleRanges: [],
                entityRanges: [],
              },
            ],
            entityMap: {},
          },
        }],
        ['Image', { href: 'http://i.imgur.com/j2nZp8k.gif' }],
        ['ContentBox', {
          rawContentState: {
            blocks: [
              {
                key: 'db2mm',
                text: storageIpsum,
                type: 'unstyled',
                depth: 0,
                inlineStyleRanges: [],
                entityRanges: [],
              },
            ],
            entityMap: {},
          },
        }],
        'Carousel',
      ],
      menu: { items: ['edit', 'delete'] },
    },
  ),
)(StackingThreeColumn);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
